import { Helmet, HelmetProvider } from 'react-helmet-async';
import MissingDocumentsSection from "shared/components/rental/sections/missing-documents-section";

const MissingDocuments = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Ontbrekende Documenten | Yally</title>
        </Helmet>
      </HelmetProvider>

      <MissingDocumentsSection />
    </>
  );
};

export default MissingDocuments;
